'use strict';

intellidealerAppCoreModule.factory('partCrossReferencesResource', function ($resource, appConfigurationService) {
  return {
    myDealerPartCrossReferenceDetailsByPart: $resource(appConfigurationService.basePath + '/rest/partcrossreferences/myDealerPartCrossReferenceDetailsByPart/'),
    myDealerPartCrossReferenceDetailsByPartAndLocation: $resource(appConfigurationService.basePath + '/rest/partcrossreferences/myDealerPartCrossReferenceDetailsByPartAndLocation/')
  }
});
